import React from "react";
import { Star } from "lucide-react";

export function StarRating({ rating = 0, size = 16, className = "" }) {
    const full = Math.round(rating);
    return (
        <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} su 5`}>
            {[1, 2, 3, 4, 5].map((i) => (
                <Star
                    key={i}
                    size={size}
                    className={i <= full ? "fill-gold text-gold" : "text-stone-300 dark:text-stone-600"}
                    strokeWidth={1.5}
                />
            ))}
        </span>
    );
}
